import { defineStore } from "pinia";

export const useExamePercentage = defineStore("examePercentages", {
  state: () => ({
    dataPercentages: [],
  }),

  actions: {
    setExamePercentages(value) {
      this.dataPercentages = value;
    },
  },
  persist: {
    enabled: true,
  },
});
